import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { convertToLowerCase } from "../utils/helperFns";

interface TextBoxProps {
  name?: any;
  placeHolder?: any;
  handleChange?: any;
  maxCharLength?: any;
  state?: any;
  handleOnBlur?: any;
}
const TextBoxWithoutBorder = ({
  name,
  placeHolder,
  handleChange,
  maxCharLength,
  state,
  handleOnBlur,
}: TextBoxProps) => {
  const { t } = useTranslation();
  const [restOfChar, setRestOfChar] = useState({
    lengthOfState: 0,
    restOfLength: 0,
    reachLimit: false,
  });
  const { restOfLength = 0, reachLimit = false } = restOfChar;
  const handleLength = (valueData = "") => {
    if (maxCharLength) {
      const lengthOfChar = convertToLowerCase(valueData).length;
      const rest = valueData ? maxCharLength - lengthOfChar : 0;

      setRestOfChar({
        ...restOfChar,
        restOfLength: rest,
        lengthOfState: lengthOfChar,
        reachLimit: maxCharLength === lengthOfChar ? true : false,
      });
    }
  };

  const onChange = (event: any = {}) => {
    if (handleChange) {
      handleChange(event);
    }
    const { target: { value = "" } = {} } = event;
    handleLength(value);
  };

  useEffect(() => {
    if (
      state //&& isEdit
    ) {
      const x: any = document.querySelector(`#${name}`);
      // if (!x?.value) {
      x.value = state;
      handleLength(state);
      // }
    } else {
      handleLength(state);
    }
  }, [state]);
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <TextField
        variant='filled'
        size='small'
        name={name}
        value={state}
        className='inputBase noBorder'
        placeholder={placeHolder}
        id={name}
        sx={{
          width: "100%",
          border: "none ",
          "& input": {
            fontSize: "20px",
            fontWeight: "700",
            "&::placeholder": {
              color: (theme) => theme.palette.customColor.LABEL,
              fontSize: "20px",
            },
          },
          "& .Platform-x-FilledInput-root": {
            border: "none",
            "&.Mui-focused": {
              border: "none",
            },
          },
          "& fieldset": { border: "none " },
          padding: "0px !important",
          height: "auto !important",
        }}
        inputProps={{
          maxLength: maxCharLength,
          readOnly: false,
        }}
        onChange={(e) => onChange(e)}
        onBlur={(e) => handleOnBlur && handleOnBlur(e)}
      />

      {maxCharLength ? (
        <Typography variant='p3regular' sx={{ color: (theme) => theme.palette.customColor.LABEL }}>
          {reachLimit ? <>0</> : restOfLength ? `${restOfLength}` : `${maxCharLength}`}
        </Typography>
      ) : null}
    </Box>
  );
};
export default TextBoxWithoutBorder;
